import React from 'react';
import { resizeImage } from '../../utils/ResizeImage';
import styles from './BrandHeader.less';
export var logoPlaceHolder = '//www.static-immobilienscout24.de/statpic/logoplaceholder/926b3d895d7a22b0a48936990a3eee7e_Placeholder-Medium-Default.png';
var defaultBrandColor = '#e0e0e0';
var BrandHeader = function BrandHeader(_ref) {
  var company = _ref.company,
    children = _ref.children;
  var logoUrl = company.logoUrl,
    brandColor = company.brandColor;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.brandHeader, " grid grid-align-center padding-top-none")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.logoSlot, " grid-item")
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    alt: "brandlogo",
    className: "".concat(styles.companyLogo, " "),
    src: logoUrl ? resizeImage(logoUrl, 300, 48, 'png') : logoPlaceHolder
  })), /*#__PURE__*/React.createElement("div", {
    "data-testid": "brand-color",
    className: "".concat(styles.brandBar, " grid-item"),
    style: {
      backgroundColor: brandColor || defaultBrandColor
    }
  }, children));
};
export default BrandHeader;